var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 102,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(1.8914243239621995,0,0,2.0843202149151567,-4.250275248921693,-62.5885500539383) ",
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Raleway, Helvetica, Arial, sans-serif",
    fontSize: 24,
    id: "svg_3",
    y: 73.490685,
    x: 2.613209,
    strokeOpacity: "null",
    strokeWidth: 0,
    fill: "#000000"
  }, "DEEDSEARCH"), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#8FB4CA",
    d: "m320.692,0l-36.923,0l0,9.23077l36.923,0l0,-9.23077zm-24.615,12.3077l36.923,0l0,9.2308l-36.923,0l0,-9.2308zm12.308,12.3077l-36.923,0l0,9.2307l36.923,0l0,-9.2307zm-18.462,12.3077l-36.923,0l0,9.2308l36.923,0l0,-9.2308z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoen);
export default __webpack_public_path__ + "static/media/logo.en.cb5c6fc1bfa9938bc8199edd6cddcc81.svg";
export { ForwardRef as ReactComponent };